<template>
    <div>
        <b-form @submit.prevent="saveTipPrudence()" data-vv-scope="formTipPrudence">
            <b-row>
                <b-col md="6">
                    <b-form-group>
                        <label>Código <span class="text-danger">*</span></label>
                        <b-form-input v-model="tipPrudence.code" type="text" class="form-control" name="code"
                            v-validate="'required|max:20'" data-vv-as=" " maxlength="21" />
                        <span class="text-danger small" v-text="errors.first('formTipPrudence.code')" />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group>
                        <label>Nombre <span class="text-danger">*</span></label>
                        <b-form-input v-model="tipPrudence.name" type="text" class="form-control" name="name"
                            v-validate="'required'" data-vv-as=" " />
                        <span class="text-danger small" v-text="errors.first('formTipPrudence.name')" />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <label>Tipo de consejo <span class="text-danger">*</span></label>
                    <b-form-group>
                        <el-select v-model="tipPrudence.prudence_tip_type_id" clearable filterable size="medium"
                            placeholder="Buscar tipo de consejo" name="prudence_tip_type_id" v-validate="'required'"
                            data-vv-as=" ">
                            <el-option v-for="item in activeTypesTipPrudenceSga" :key="item.id" :label="item.name"
                                :value="item.id" />
                        </el-select>
                        <span class="text-danger small" v-text="errors.first('formTipPrudence.prudence_tip_type_id')" />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group>
                        <b-form-checkbox v-model="parent" name="parent" :value="true" :unchecked-value="false" switch>
                            Agregar consejo de prudencia padre
                        </b-form-checkbox>
                    </b-form-group>
                </b-col>

                <b-col md="12" v-if="parent">
                    <b-form-group>
                        <label>Consejo de prudencia padre <span class="text-danger">*</span></label>
                        <el-select v-model="tipPrudence.parent_prudence_tip_code_ids" clearable filterable multiple
                            size="medium" placeholder="Seleccionar indicación de peligro"
                            name="parent_prudence_tip_code_ids" v-validate="parent == true ? 'required' : ''"
                            data-vv-as=" ">
                            <el-option v-for="item in filteredActiveTipsPrudenceSga" :key="item.id"
                                :label="item.code + ' - ' + item.name" :value="item.id" />
                        </el-select>
                        <span class="text-danger small"
                            v-text="errors.first('formTipPrudence.parent_prudence_tip_code_ids')" />
                    </b-form-group>
                </b-col>

                <b-col md="12" v-if="hasValidLanguages">
                    <b-list-group>
                        <b-list-group-item v-for="language in tipPrudence.sga_prudence_tip_code_languages"
                            :key="language.id" v-if="language.sga_language.code !== 'ES'">
                            <div class="d-flex align-items-center">
                                <div class="flex-grow-1">
                                    <span class="fw-bold">
                                        <input v-model="language.value" type="text"
                                            class="form-control form-control-sm w-100" />
                                    </span>
                                </div>
                                <div class="ms-auto ml-2">
                                    <b-badge variant="primary">{{ language.sga_language.code }}</b-badge>
                                    <span class="text-muted"> - {{ language.sga_language.name }}</span>
                                </div>
                            </div>
                        </b-list-group-item>
                    </b-list-group>
                </b-col>

                <b-col md="12" class="mt-3 d-flex justify-content-end align-items-center">
                    <b-form-group>
                        <b-button variant="danger" @click="cancelTipPrudence">
                            <i class="fa fa-reply"></i>
                            <span class="ml-1" v-text="'Cancelar'"></span>
                        </b-button>
                        <b-button type="submit" variant="primary" class="mx-1">
                            <i class="fa fa-save"></i>
                            <span class="ml-1" v-text="'Guardar'"></span>
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-form>

    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
export default {
    name: 'FormTipsPrudence',

    data() {
        return {
            parent: false,
        };
    },

    computed: {
        ...mapState('sgaTipsPrudence', ['action', 'tipPrudence', 'activeTipsPrudenceSga']),
        ...mapState('sgaTypesTipPrudence', ['activeTypesTipPrudenceSga']),

        hasValidLanguages() {
            return Array.isArray(this.tipPrudence.sga_prudence_tip_code_languages) &&
                this.tipPrudence.sga_prudence_tip_code_languages.length > 0;
        },

        // Filtrar los consejos de prudencia activos para no mostrar el consejo de prudencia actual
        filteredActiveTipsPrudenceSga() {
            if (this.tipPrudence.id !== null && Array.isArray(this.activeTipsPrudenceSga)) {
                return this.activeTipsPrudenceSga.filter(item => item.id !== this.tipPrudence.id);
            }
            return this.activeTipsPrudenceSga;
        }
    },

    watch: {
        parent(value) {
            if (!value) {
                this.tipPrudence.parent_prudence_tip_code_ids = [];
            }
        },

        // Asignar los códigos de los consejos de prudencia padre
        "tipPrudence.parent_prudence_tip_codes": {
            handler(value) {
                if (Array.isArray(value) && value.length > 0) {
                    this.parent = true;
                    this.tipPrudence.parent_prudence_tip_code_ids = value.map(item => item.parent_prudence_tip_code_id);
                }
            },
            deep: true
        }
    },

    async created() {
        await this.getActiveTipsPrudenceSga();
    },

    methods: {
        ...mapActions('sgaTipsPrudence', ['createTipPrudenceSga', 'getTipsPrudenceSga', 'updateTipPrudenceSga', 'getActiveTipsPrudenceSga']),
        ...mapMutations('sgaTipsPrudence', ['setDefaultTipPrudenceSga']),

        cancelTipPrudence() {
            this.setDefaultTipPrudenceSga();
            this.$bvModal.hide('modal_create_tip_prudence');
        },

        async cancelAndGetTipPrudence() {
            this.cancelTipPrudence();
            await this.getTipsPrudenceSga();
        },

        async saveTipPrudence() {
            const isValid = await this.$validator.validateAll('formTipPrudence');
            if (!isValid) return;

            let flag = false;
            if (this.action === 'edit') {
                flag = await this.updateTipPrudenceSga(this.tipPrudence);
            } else {
                flag = await this.createTipPrudenceSga(this.tipPrudence);
            }

            if (flag) {
                this.cancelAndGetTipPrudence();
            }
        }
    }
}
</script>
